<script setup>
const route = useRoute()
const router = useRouter()
const { isDialogVisible, returnTo, closeAuthDialog } = useAuthDialog()
const isOtpStep = ref(false)
const isLegalDialogVisible = ref(false)
const legalSection = ref("terms")

const showLegal = section => {
  legalSection.value = section
  isLegalDialogVisible.value = true
}

const resetDialog = () => {
  isOtpStep.value = false
  isLegalDialogVisible.value = false
}

const loginSucceeded = async () => {
  const target = returnTo.value
  closeAuthDialog()
  resetDialog()

  if (target && target !== route.fullPath)
    await router.push(target)
}

watch(isDialogVisible, value => {
  if (!value) resetDialog()
})
</script>

<template>
  <VDialog
    :model-value="isDialogVisible"
    width="auto"
    max-width="calc(100% - 24px)"
    persistent
    @update:model-value="value => !value && closeAuthDialog()"
  >
    <div class="auth-dialog" dir="rtl">
      <button type="button" aria-label="بستن" @click="closeAuthDialog">
        <VIcon icon="tabler-x" size="21" />
      </button>
      <UsersLogin
        v-if="!isOtpStep"
        @login-success="isOtpStep = true"
        @auth-success="loginSucceeded"
        @show-legal="showLegal"
      />
      <UsersOtp
        v-else
        @back="isOtpStep = false"
        @otp-success="loginSucceeded"
      />
    </div>

  </VDialog>

  <AppAuthLegalDialog
    v-model="isLegalDialogVisible"
    :initial-section="legalSection"
  />
</template>

<style lang="scss" scoped>
.auth-dialog { position: relative; max-height: calc(100dvh - 24px); overflow-x: hidden; overflow-y: auto; border-radius: 18px; background: #fafafa; }
.auth-dialog > button { position: absolute; z-index: 2; top: 12px; left: 12px; display: grid; width: 34px; height: 34px; place-items: center; border: 0; border-radius: 50%; background: rgba(var(--v-theme-on-surface),.055); color: rgba(var(--v-theme-on-surface),.68); cursor: pointer; }
</style>
